import {
  type NotificationDto,
  type SimplePageNotificationDto,
} from '@onroadvantage/optix-safeandsound-openapi';
import {useQuery} from '@tanstack/react-query';

import {NOTIFICATIONS_LIST_QUERY_KEY} from './notificationQueryKeys';
import {notificationsApi} from '../../../../api';

const NOTIFICATIONS_PAGE_SIZE = 10;
const NOTIFICATIONS_SORT = ['createdAt,desc'];

export interface UseNotificationListReturn {
  notifications: NotificationDto[];
  loading: boolean;
  isError: boolean;
}

export const useNotificationList = (
  enabled: boolean,
): UseNotificationListReturn => {
  const query = useQuery({
    queryKey: NOTIFICATIONS_LIST_QUERY_KEY,
    queryFn: async (): Promise<SimplePageNotificationDto> => {
      return await notificationsApi.search2({
        page: 0,
        perPage: NOTIFICATIONS_PAGE_SIZE,
        sort: NOTIFICATIONS_SORT,
      });
    },
    enabled,
    staleTime: 0,
  });

  const notifications = (query.data?.content ?? []).filter(
    (notification) => notification.archivedAt == null,
  );

  return {
    notifications,
    loading: query.isLoading,
    isError: query.isError,
  };
};
